define("shared/components/shared/profile-timezone-select", ["exports", "@ember/component", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _utils, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="{{this.fadeIn}} {{this.wrapperClass}}" data-test-id="profile-timezone-select" {{did-insert this.onInsert}}>
    {{#if this.showToggle}}
  
      <p class="u--m__tb__lg">
        {{t "authorization.create_account.timezone"}}
        {{@user.timeZone}}
        <a
          class="u--text--black u--text--underline u--p__l qa--signup_toggle_timezone_selector"
          data-test-id="profile-timezone-select-toggle"
          {{on "click" (set this "showToggle" false)}}
        >
          {{t "authorization.create_account.change"}}
        </a>
      </p>
  
    {{else}}
  
      <div class="u--fadeIn">
        <label for="time_zone_selector">
          {{t "account.overview.preferences.timezone"}}
        </label>
        {{#if @showGuessLink}}
          <a class="u--m__l__xs u--text--sm u--text--uppercase" onclick={{action "guessTimezone"}}>
            {{t "account.overview.preferences.guess_timezone"}}
          </a>
        {{/if}}
        <select
          class="qa--signup_timezone_selector {{this.inputClass}}"
          data-test-id="profile-timezone-select-select"
          id="time_zone_selector"
          {{on "change" this.setTimezone}}
        >
          {{#each this.allTimezones as |timezone|}}
            <option selected={{are-equal timezone.identifier @user.timeZoneIdentifier}} value={{timezone.name}}>
              {{timezone.name}}
            </option>
          {{/each}}
        </select>
      </div>
  
    {{/if}}
  </div>
  */
  {
    "id": "yVa+sEAD",
    "block": "[[[11,0],[16,0,[29,[[30,0,[\"fadeIn\"]],\" \",[30,0,[\"wrapperClass\"]]]]],[24,\"data-test-id\",\"profile-timezone-select\"],[4,[38,0],[[30,0,[\"onInsert\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"showToggle\"]],[[[1,\"\\n    \"],[10,2],[14,0,\"u--m__tb__lg\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"authorization.create_account.timezone\"],null]],[1,\"\\n      \"],[1,[30,1,[\"timeZone\"]]],[1,\"\\n      \"],[11,3],[24,0,\"u--text--black u--text--underline u--p__l qa--signup_toggle_timezone_selector\"],[24,\"data-test-id\",\"profile-timezone-select-toggle\"],[4,[38,3],[\"click\",[28,[37,4],[[30,0],\"showToggle\",false],null]],null],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"authorization.create_account.change\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"]],[]],[[[1,\"\\n    \"],[10,0],[14,0,\"u--fadeIn\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,\"for\",\"time_zone_selector\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"account.overview.preferences.timezone\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,2],[[[1,\"        \"],[10,3],[14,0,\"u--m__l__xs u--text--sm u--text--uppercase\"],[15,\"onclick\",[28,[37,5],[[30,0],\"guessTimezone\"],null]],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"account.overview.preferences.guess_timezone\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[11,\"select\"],[16,0,[29,[\"qa--signup_timezone_selector \",[30,0,[\"inputClass\"]]]]],[24,\"data-test-id\",\"profile-timezone-select-select\"],[24,1,\"time_zone_selector\"],[4,[38,3],[\"change\",[30,0,[\"setTimezone\"]]],null],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,0,[\"allTimezones\"]]],null]],null],null,[[[1,\"          \"],[10,\"option\"],[15,\"selected\",[28,[37,8],[[30,3,[\"identifier\"]],[30,1,[\"timeZoneIdentifier\"]]],null]],[15,2,[30,3,[\"name\"]]],[12],[1,\"\\n            \"],[1,[30,3,[\"name\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[3]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"]],[]]],[13]],[\"@user\",\"@showGuessLink\",\"timezone\"],false,[\"did-insert\",\"if\",\"t\",\"on\",\"set\",\"action\",\"each\",\"-track-array\",\"are-equal\"]]",
    "moduleName": "shared/components/shared/profile-timezone-select.hbs",
    "isStrictMode": false
  });
  let ProfileTimezoneSelectComponent = _exports.default = (_class = class ProfileTimezoneSelectComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "userConfig", _descriptor, this);
      _initializerDefineProperty(this, "showToggle", _descriptor2, this);
      _defineProperty(this, "fadeIn", 'u--fadeIn');
      _defineProperty(this, "defaultSize", 'lg');
    }
    get size() {
      return this.args.size || this.defaultSize;
    }
    get wrapperClass() {
      return 'o--formWrapper' + (this.size === 'lg' ? '--lg' : '');
    }
    get inputClass() {
      return 'o--form__select' + (this.size === 'lg' ? '--lg' : '');
    }
    get allTimezones() {
      return this.userConfig.timezones;
    }
    onInsert() {
      this.showToggle = this.args.showToggle || false;
      if ((0, _utils.isEmpty)(this.args.user.timeZone) || (0, _utils.isEmpty)(this.args.user.timeZoneIdentifier)) {
        this.guessTimezone();
      }
    }
    guessTimezone() {
      const timeZone = moment.tz.guess();
      this.args.user.timeZone = timeZone;
      this.args.user.timeZoneIdentifier = timeZone;
    }
    setTimezone(_ref) {
      let {
        target: {
          value
        }
      } = _ref;
      this.args.user.timeZone = value;
      this.args.user.timeZoneIdentifier = value;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showToggle", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "onInsert", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "guessTimezone", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "guessTimezone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTimezone", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setTimezone"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProfileTimezoneSelectComponent);
});